import Base from './Base'
import gsap from 'gsap'

import { evt, utils, store } from '@/core'

const { qs, qsa } = utils
const { dom, bounds } = store

export default class extends Base {
	onEnter() {
		super.onEnter()
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted()
		const formCaucion = qs('.forms_caucion');

		//FORM CAUCIÓN
		if(formCaucion){
			console.log('esiste')
			this._setYear()
			this._logicForm()

			qs('.plazo-contrato-range').addEventListener('change', ()=>{
				this._checkTotals(qs('.plazo-contrato-range').value)
			})

			qs('select[name=FORMA_PAGO]').addEventListener('change', ()=>{
				let FP = qs('select[name=FORMA_PAGO]').value
				let price = qs('.price')
				price.classList.remove('mercado_pago')
				price.classList.remove('transferencia')
				price.classList.add(FP)
			})


			//OpenForms
			qs('#initCoti').addEventListener('click', ()=>{
				//ARMA FORM
				qs('input[name=VIVIENDA_COMPLETE_FORM]').value = 'Vivienda';
				qs('input[name=PLAZO_COMPLETE_FORM]').value = qs('.plazo-contrato-range').value
				qs('input[name=VALOR_MES_COMPLETE_FORM]').value = qs('input[name=MES_ALQUILER]').value
				qs('input[name=VALOR_TOTAL_COMPLETE_FORM]').value = qs('input[name=TOTAL_ALQUILER]').value
				qs('input[name=EXPENSAS_MES_COMPLETE_FORM]').value = qs('input[name=MES_EXPENSAS]').value
				qs('input[name=EXPENSAS_TOTAL_COMPLETE_FORM]').value = qs('input[name=TOTAL_EXPENSAS]').value
				qs('input[name=SERVICIOS_MES_COMPLETE_FORM]').value = qs('input[name=MES_SERVICIOS]').value
				qs('input[name=SERVICIOS_TOTAL_COMPLETE_FORM]').value = qs('input[name=TOTAL_SERVICIOS]').value
				qs('input[name=OCUPACION_TOTAL_COMPLETE_FORM]').value = qs('input[name=TOTAL_INDEBIDA]').value
				qs('input[name=PAGO_COMPLETE_FORM]').value = qs('select[name=FORMA_PAGO]').value
				qs('input[name=COSTO_COMPLETE_FORM]').value = qs('select[name=FORMA_PAGO]').value == 'mercado_pago' ? qs('h4[data-rel=mercado_pago]').innerHTML : qs('h4[data-rel=transferencia]').innerHTML
				qs('input[name=INGRESOS_COMPLETE_FORM]').value = qs('#SALARY').innerHTML
				qs('input[name=sueldo_requerido]').value = qs('#SALARY').innerHTML

				qs('.forms_caucion.floating.solicitud').classList.add('openform')
			})
			qs('#sendEmail').addEventListener('click', ()=>{
				//ARMA FORM
				qs('input[name=VIVIENDA_SINGLE_FORM]').value = 'Vivienda';
				qs('input[name=PLAZO_SINGLE_FORM]').value = qs('.plazo-contrato-range').value
				qs('input[name=VALOR_MES_SINGLE_FORM]').value = qs('input[name=MES_ALQUILER]').value
				qs('input[name=VALOR_TOTAL_SINGLE_FORM]').value = qs('input[name=TOTAL_ALQUILER]').value
				qs('input[name=EXPENSAS_MES_SINGLE_FORM]').value = qs('input[name=MES_EXPENSAS]').value
				qs('input[name=EXPENSAS_TOTAL_SINGLE_FORM]').value = qs('input[name=TOTAL_EXPENSAS]').value
				qs('input[name=SERVICIOS_MES_SINGLE_FORM]').value = qs('input[name=MES_SERVICIOS]').value
				qs('input[name=SERVICIOS_TOTAL_SINGLE_FORM]').value = qs('input[name=TOTAL_SERVICIOS]').value
				qs('input[name=OCUPACION_TOTAL_SINGLE_FORM]').value = qs('input[name=TOTAL_INDEBIDA]').value
				qs('input[name=PAGO_SINGLE_FORM]').value = qs('select[name=FORMA_PAGO]').value
				qs('input[name=COSTO_SINGLE_FORM]').value = qs('select[name=FORMA_PAGO]').value == 'mercado_pago' ? qs('h4[data-rel=mercado_pago]').innerHTML : qs('h4[data-rel=transferencia]').innerHTML
				qs('input[name=INGRESOS_SINGLE_FORM]').value = qs('#SALARY').innerHTML

				console.log(qs('input[name=COSTO_SINGLE_FORM]').value)

				qs('.forms_caucion.floating.byemail').classList.add('openform')
			})
			qsa('.close.back').forEach(e => e.addEventListener('click', 
				()=>{
				qsa('.forms_caucion.floating').forEach(t => t.classList.remove('openform'))
				})
			)

			//Avalista
			this._AvalistaCheck()

			this._CloneAvalista()

		}
	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}
	_setYear(){
		let y = qsa('.years-btn')
		let range = qs('.plazo-contrato-range')
		y.forEach(e => e.addEventListener('click', ()=>{
			let plazo = e.dataset.rel
			range.value = plazo
			this._checkTotals(plazo)
		}));
	}
	_logicForm(){
		let PLAZO = new Array(0,12,24,36)
		//ALQUILER
		let ALQUILER_MES = qs('input[name=MES_ALQUILER]')
		let ALQUILER_TOTAL = qs('input[name=TOTAL_ALQUILER]')
		ALQUILER_MES.addEventListener('keyup', ()=>{ 
			let ANIOS = qs('.plazo-contrato-range').value
			ALQUILER_TOTAL.value = Number( ALQUILER_MES.value ) * Number( PLAZO[ANIOS] )

			console.log(
				ALQUILER_TOTAL.value.replace(/\D/g, "")
				.replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ".")
			)
			//totals
			this._Total()
		})
		//EXPENSAS
		let EXPENSAS_CHECK = qs('input[name=MES_EXPENSAS_CHECK]')
		let EXPENSAS_MES = qs('input[name=MES_EXPENSAS]')
		let EXPENSAS_TOTAL = qs('input[name=TOTAL_EXPENSAS]')
		EXPENSAS_CHECK.addEventListener('change', ()=>{
			if(EXPENSAS_CHECK.checked){
				EXPENSAS_MES.disabled = false
			}else{
				EXPENSAS_MES.disabled = true
				EXPENSAS_MES.value=''
				EXPENSAS_TOTAL.value=''
				//totals
				this._Total()
			}
		})
		EXPENSAS_MES.addEventListener('keyup', ()=>{ 
			let ANIOS = qs('.plazo-contrato-range').value
			if(EXPENSAS_MES.value > (ALQUILER_MES.value / 2)){
				EXPENSAS_MES.classList.add('error')
			}else{
				EXPENSAS_MES.classList.remove('error')
				EXPENSAS_TOTAL.value = Number( EXPENSAS_MES.value ) * Number( PLAZO[ANIOS] )
			}
			//totals
			this._Total()
		})
		//SERVICIOS
		let SERVICIOS_CHECK = qs('input[name=MES_SERVICIOS_CHECK]')
		let SERVICIOS_MES = qs('input[name=MES_SERVICIOS]')
		let SERVICIOS_TOTAL = qs('input[name=TOTAL_SERVICIOS]')
		SERVICIOS_CHECK.addEventListener('change', ()=>{
			if(SERVICIOS_CHECK.checked){
				SERVICIOS_MES.disabled = false
			}else{
				SERVICIOS_MES.disabled = true
				SERVICIOS_MES.value=''
				SERVICIOS_TOTAL.value=''
				//totals
				this._Total()
			}
		})
		SERVICIOS_MES.addEventListener('keyup', ()=>{ 
			let ANIOS = qs('.plazo-contrato-range').value
			if(SERVICIOS_MES.value > (ALQUILER_MES.value / 5)){
				SERVICIOS_MES.classList.add('error')
			}else{
				SERVICIOS_MES.classList.remove('error')
				SERVICIOS_TOTAL.value = Number( SERVICIOS_MES.value ) * Number( PLAZO[ANIOS] )
			}
			//totals
			this._Total()
		})
		//OCUPACION INDEBIDA
		let INDEBIDA_CHECK = qs('input[name=MES_INDEBIDA_CHECK]')
		let INDEBIDA_TOTAL = qs('input[name=TOTAL_INDEBIDA]')
		
		INDEBIDA_CHECK.addEventListener('change', ()=>{
			if(INDEBIDA_CHECK.checked){
				INDEBIDA_TOTAL.value = ALQUILER_MES.value
			}else{
				INDEBIDA_TOTAL.value = ''
			}
			//totals
			this._Total()
		})
	}
	_checkTotals(A){	
		let PLAZO = new Array(0,12,24,36)
		let ALQUILER_MES = qs('input[name=MES_ALQUILER]')
		let ALQUILER_TOTAL = qs('input[name=TOTAL_ALQUILER]')
		let EXPENSAS_MES = qs('input[name=MES_EXPENSAS]')
		let EXPENSAS_TOTAL = qs('input[name=TOTAL_EXPENSAS]')
		let SERVICIOS_MES = qs('input[name=MES_SERVICIOS]')
		let SERVICIOS_TOTAL = qs('input[name=TOTAL_SERVICIOS]')

		ALQUILER_TOTAL.value = Number( ALQUILER_MES.value ) * Number( PLAZO[A] ) !== 0 ? Number( ALQUILER_MES.value ) * Number( PLAZO[A] ) : ''
		EXPENSAS_TOTAL.value = Number( EXPENSAS_MES.value ) * Number( PLAZO[A] ) !== 0 ? Number( EXPENSAS_MES.value ) * Number( PLAZO[A] ) : ''
		SERVICIOS_TOTAL.value = Number( SERVICIOS_MES.value ) * Number( PLAZO[A] ) !== 0 ? Number( SERVICIOS_MES.value ) * Number( PLAZO[A] ) : ''

		//total
		this._Total()
	}
	_Total(){
		let ALQUILER_TOTAL = qs('input[name=TOTAL_ALQUILER]')
		let EXPENSAS_TOTAL = qs('input[name=TOTAL_EXPENSAS]')
		let SERVICIOS_TOTAL = qs('input[name=TOTAL_SERVICIOS]')
		let INDEBIDA_TOTAL = qs('input[name=TOTAL_INDEBIDA]')
		let PRICE_MP = qs('.price h4.mp')
		let PRICE_TR = qs('.price h4.tr')

		let valorOriginal = Number( ALQUILER_TOTAL.value ) + Number( EXPENSAS_TOTAL.value ) + Number( SERVICIOS_TOTAL.value ) + Number( INDEBIDA_TOTAL.value )
		valorOriginal = valorOriginal * .041

		const valorFormateadoMP = new Intl.NumberFormat("es-ES", {
			maximumFractionDigits: 3,
		}).format(valorOriginal)
		const valorFormateadoTR = new Intl.NumberFormat("es-ES", {
			maximumFractionDigits: 3,
		}).format(valorOriginal * .9)

		PRICE_MP.innerHTML = '$'+valorFormateadoMP+'*'
		PRICE_TR.innerHTML = '$'+valorFormateadoTR+'*'

		if(valorOriginal > 0){
			qs('#initCoti').disabled = false
			qs('#sendEmail').disabled = false
		}else{
			qs('#initCoti').disabled = true
			qs('#sendEmail').disabled = true
		}

		this._salary()

	}
	_salary(){
		let SALARY = qs('#SALARY')
		let ALQUILER_MES = qs('input[name=MES_ALQUILER]')
		let EXPENSAS_MES = qs('input[name=MES_EXPENSAS]')
		let SERVICIOS_MES = qs('input[name=MES_SERVICIOS]')
		let TOTAL =  Number( ALQUILER_MES.value ) + Number( EXPENSAS_MES.value ) + Number( SERVICIOS_MES.value )
		TOTAL = (TOTAL * 100) / 30
		const salaryFormateado = new Intl.NumberFormat("es-ES", {
			maximumFractionDigits: 3,
		}).format(TOTAL)
		SALARY.innerHTML = salaryFormateado

		qs('input[name=sueldo_requerido]').value = salaryFormateado
	}
	_AvalistaCheck(){

		let AVALISTA_CHECK = qsa('input[name=AVALISTA_CHECK]')
		let CLONE = qs('#clone')
		let btnClone = qs('.btn-clone')
		
		AVALISTA_CHECK.forEach( c => {
			c.addEventListener('change', ()=>{
				if(c.value == 'Si'){
					CLONE.classList.remove('disabled')
					btnClone.style.display = 'block'
				}else{
					CLONE.classList.add('disabled')
					btnClone.style.display = 'none'

				}
			})
		})
	}
	_CloneAvalista(){
		let btnClone = qs('.btn-clone')
		let CLONE = qs('#clone')
		let CONTENT = qs('#contentClones')
		let o = 0;
		btnClone.addEventListener('click', () =>{
			let CLONENODE = CLONE.cloneNode(true);
			CLONENODE.setAttribute('id', 'clone_'+o)
			CONTENT.prepend(CLONENODE)
		})
	}
}